export const TILE_CLASS =
  'relative flex min-w-0 flex-col gap-[var(--space-inline)] rounded-[var(--radius-surface)] border border-[color:var(--color-border)] bg-[color:var(--color-surface)] p-[var(--space-group)]'
